/**
 * WP dependencies
 */

import { RichText, useBlockProps } from '@wordpress/block-editor';

const save = ({ attributes }) => {
  const {
    heading,
    headingColor,
    text,
    textColor,
    headingLevel
  } = attributes;

  const blockProps = useBlockProps.save({
    className: 'block__heading-with-paragraph'
  });

  /**
   * Handle additional logic
   */

  const showTextBlock = !!( heading.length > 0 || text.length > 0 );

  /**
   * Handle element styles
   */

  const hColor = headingColor ? { color: headingColor } : undefined;
  const tColor = textColor ? { color: textColor } : undefined;

  return (
    showTextBlock && (
      <div { ...blockProps }>
        <div className='heading-with-paragraph--inner'>
          { heading.length > 0 && (
            <RichText.Content
              className={`heading-${headingLevel} heading-with-paragraph__heading`}
              style={ { ...hColor } }
              tagName={`h${headingLevel}`}
              value={ heading }
            />
          ) }

          { text.length > 0 && (
            <RichText.Content
              className='paragraph-1 heading-with-paragraph__text'
              style={ { ...tColor } }
              tagName='p'
              value={ text }
            />
          ) }

        </div>
      </div>
    )
  );
};

export default save;
